export const GET_HOSPITALS = 'GET_HOSPITALS';
export const CLEAR_HOSPITALS = 'CLEAR_HOSPITALS';

export const HOSPITAL_MAX_FETCH_NUM = 100;
